import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

/**
 * Povolené špeciálne znaky – musia zodpovedať zoznamu v hinte formulárov
 * (registration.section1.password.hint) a politike na backende.
 * Pomlčka je escapovaná, inak by `)-=` tvorilo rozsah znakov (vrátane číslic).
 */
const SPECIAL_CHARACTERS = /[~!@#$%^&*()\-_=+[\]{}|;:,.<>/?]/;

export function passwordValidator(translate: TranslateService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';
    let invalidStringMsg = '';

    translate.get('error.validation.password.notContain').subscribe((response: string) => {
      invalidStringMsg = response;
    });

    const validSmallLetters = /[a-z]/.test(value);
    if (!validSmallLetters) {
      translate.get('error.validation.password.smallLetters').subscribe((response: string) => {
        invalidStringMsg += response;
      });
    }

    const validCapitalLetters = /[A-Z]/.test(value);
    if (!validCapitalLetters) {
      translate.get('error.validation.password.capitalLetters').subscribe((response: string) => {
        invalidStringMsg += response;
      });
    }

    const validNum = /[0-9]/.test(value);
    if (!validNum) {
      translate.get('error.validation.password.number').subscribe((response: string) => {
        invalidStringMsg += response;
      });
    }

    const validSpecial = SPECIAL_CHARACTERS.test(value);
    if (!validSpecial) {
      translate.get('error.validation.password.special').subscribe((response: string) => {
        invalidStringMsg += response;
      });
    }
    if (invalidStringMsg.endsWith(',')) {
      invalidStringMsg = invalidStringMsg.slice(0, -1);
    }
    invalidStringMsg += '.';

    return !validSmallLetters || !validCapitalLetters || !validNum || !validSpecial
      ? { invalidPassword: { value: control.value, msg: invalidStringMsg } }
      : null;
  };
}
